import { buildResponsiveSize } from '@tvg/fuse-utils';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import { configIcon } from './configIcon';

const getVolumeByViewport = (iconSize) => `
	width: ${configIcon[iconSize]?.width};
	height: ${configIcon[iconSize]?.height};
`;

const setVolume = (responsiveSize) => {
	const [isResponsive, setViewportCss] = buildResponsiveSize(responsiveSize);

	return isResponsive ? setViewportCss(getVolumeByViewport) : getVolumeByViewport(responsiveSize);
};

const setSize = (height, width, responsiveSize) => {
	if (height || width) {
		const iconHeight = height || configIcon.xsmall.height;
		const iconWidth = width || iconHeight;

		return `
			height: ${iconHeight};
			width: ${iconWidth};
		`;
	}

	return setVolume(responsiveSize);
};

const StyledIcon = styled.span
	.withConfig({
		shouldForwardProp: (prop) => !['responsiveSize', 'icon'].includes(prop),
	})
	.attrs({
		className: `fuse-icon`,
	})`
	${({ icon, color, height, width, responsiveSize }) => {
		const iconColor = color;
		return `
			background: ${iconColor};
			display: inline-flex;
			mask: url('data:image/svg+xml,${encodeURIComponent(
		renderToStaticMarkup(icon),
	)}') center/contain no-repeat;
			-webkit-mask: url('data:image/svg+xml,${encodeURIComponent(
		renderToStaticMarkup(icon),
	)}') center/contain no-repeat;
			position: relative;

			${setSize(height, width, responsiveSize)};

			&[disabled] {
				background-color: var(--color-global-grey400);
			}
		`;
	}}
`;
// const StyledIcon = styled.div`
// 	width: 50px;
// 	height: 50px;
// 	background: red;
// `;

export default StyledIcon;
